import type { Asserts } from 'yup';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { rlvSchema } from '@/features/Sparten/rlv/schema/inputSchema';

export const inputSchema = rlvSchema;

export type InputStore = Asserts<typeof inputSchema>;

export const useRlvInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'RlvInputStore',
);
